<template>
  <basic-container>
    <!-- 搜索栏 -->
    <div class="search-container">
      <el-form
        :inline="true"
        :model="searchParams"
        size="small"
        label-width="120px"
      >
        <el-form-item label="">
          <el-select
            v-model="searchParams.pushType"
            placeholder="请选择通知类型"
            style="width: 240px"
            clearable
          >
            <el-option label="消息盒子" :value="1"></el-option>
            <el-option label="push提醒" :value="2"></el-option>
            <el-option label="短信通知" :value="3"></el-option>
            <el-option label="公众号" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select
            v-model="searchParams.actionMode"
            placeholder="请选择触发条件"
            style="width: 240px"
            clearable
          >
            <el-option
              v-for="item in triggerOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-date-picker
            v-model="searchParams.sendTimeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 350px"
            clearable
          ></el-date-picker>
        </el-form-item>
        <!-- 手机号搜索  -->
        <el-form-item label="">
          <el-input
            v-model="searchParams.uuid"
            placeholder="请输入用户账号"
            style="width: 140px"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input
            v-model="searchParams.notificationId"
            placeholder="请输入通知ID"
            style="width: 240px"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            v-auth="'NOTICE_LIST_SEARCH'"
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="handleSearch"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table-container">
      <el-table v-loading="loading" :data="tableData" style="width: 100%">
        <el-table-column
          prop="notificationId"
          label="ID"
          width="180"
        ></el-table-column>
        <el-table-column prop="pushType" label="通知类型" min-width="120">
          <template slot-scope="scope">
            <el-tag
              v-for="(type, index) in parseNoticeTypes(scope.row.pushType)"
              :key="index"
              size="small"
              style="margin-right: 5px"
            >
              {{ getNoticeTypeName(type) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="uuid"
          label="用户帐号"
          width="120"
        ></el-table-column>
        <el-table-column prop="actionMode" label="触发条件" min-width="180">
          <template slot-scope="scope">
            {{ getTriggerConditionName(scope.row.actionMode) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="execTime"
          label="发送时间"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="viewContent"
          label="发送内容"
          min-width="300"
        ></el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <ElementPagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.current"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="searchParams.size"
          :total="searchParams.total"
        />
      </div>
    </div>
  </basic-container>
</template>

<script>
import { getNoticeRecordList } from "@/api/noticeManage/noticeManage";
import ElementPagination from "@/components/ElementPagination";
import Message from "@/components/Message";

export default {
  name: "NoticeList",
  components: {
    ElementPagination,
  },
  data() {
    return {
      loading: false,
      tableData: [],
      searchParams: {
        current: 1,
        size: 10,
        total: 0,
        pushType: "",
        userAccount: "",
        actionMode: "",
        sendTimeRange: [],
        notificationId: "",
        uuid: "",
      },
      triggerOptions: [
        { label: "会员开通提醒", value: 1 },
        { label: "会员自动续费即将扣款提醒", value: 2 },
        { label: "会员即将到期提醒", value: 3 },
        { label: "自动续费取消提醒", value: 4 },
        { label: "会员退款提醒", value: 5 },
        { label: "会员活动一次性活动", value: 6 },
        { label: "会员活动周期性活动", value: 7 },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 获取列表 */
    async getList() {
      this.loading = true;
      try {
        const params = { ...this.searchParams };
        // 处理时间范围
        if (params.sendTimeRange && params.sendTimeRange.length === 2) {
          params.startTime = params.sendTimeRange[0];
          params.endTime = params.sendTimeRange[1];
        }
        // 构建查询参数，只包含后端接口需要的字段
        const query = {
          current: params.current,
          size: params.size,
          pushType: params.pushType || undefined,
          actionMode: params.actionMode || undefined,
          notificationId: params.notificationId || undefined,
          startTime: params.startTime || undefined,
          endTime: params.endTime || undefined,
          uuid: params.uuid || undefined,
        };
        // 移除空值
        Object.keys(query).forEach((key) => {
          if (
            query[key] === undefined ||
            query[key] === "" ||
            query[key] === null
          ) {
            delete query[key];
          }
        });

        const { data } = await getNoticeRecordList(query);
        if (data.code === 200) {
          this.tableData = data.data.records || [];
          this.searchParams.total = data.data.total || 0;
        } else {
          Message.error(data.msg || "获取列表失败");
        }
      } catch (error) {
        console.error("获取列表失败", error);
        Message.error("获取列表失败");
      } finally {
        this.loading = false;
      }
    },
    /** 搜索 */
    handleSearch() {
      this.searchParams.current = 1;
      this.getList();
    },
    /** 分页大小改变 */
    handleSizeChange(val) {
      this.searchParams.size = val;
      this.searchParams.current = 1;
      this.getList();
    },
    /** 当前页改变 */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      this.getList();
    },
    /** 解析通知类型 */
    parseNoticeTypes(noticeType) {
      if (!noticeType) return [];
      return String(noticeType).split(",").filter(Boolean);
    },
    /** 获取通知类型名称 */
    getNoticeTypeName(type) {
      const typeMap = {
        1: "消息盒子",
        2: "push提醒",
        3: "短信通知",
        4: "公众号",
      };
      return typeMap[type] || "";
    },
    /** 获取触发条件名称 */
    getTriggerConditionName(actionMode) {
      const option = this.triggerOptions.find(
        (item) => item.value === actionMode
      );
      return option ? option.label : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  margin-bottom: 20px;
}

.table-container {
  padding-bottom: 40px;
  .pagination-container {
    margin-top: 16px;
    text-align: right;
  }
}
</style>
